export default __webpack_public_path__ + "static/media/mariog1.e6e90dc7.jpg";